// libs
import React, { memo } from 'react';

// components
import BottomNav from './BottomNav';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// defs
interface IBottomNavExperimentProps {
  isBottomNavEnabled: boolean;
}

function WithFlag() {
  const { enable: bottomNavV2Enabled } = useRemoteConfig('bottomNavV2');
  const isBottomNavV1Enabled = useRemoteConfig('bottom_nav_enabled');

  // if bottom nav v2 enabled do not render bottom nav v1
  // if bottom nav v1 disabled do not render bottom nav v1
  if (bottomNavV2Enabled || isBottomNavV1Enabled === false) return null;

  return <BottomNav />;
}

export default memo(WithFlag);
